import api from "./api";
import { AttrValues, CatalogAttributeSet } from "../models/CatalogAttributes";

const digits = (v: string) => v.replace(/\D/g, "");
const root = (cnpj?: string) => (cnpj && digits(cnpj).length >= 8 ? digits(cnpj).slice(0, 8) : undefined);

export const getCatalogAttributes = async (ncm: string): Promise<CatalogAttributeSet> =>
  (await api.get("/api/catalog/attributes", { params: { ncm: digits(ncm) } })).data;

export const getCatalogProductValues = async (ncm: string, product: string, cnpj?: string): Promise<AttrValues> =>
  (await api.get("/api/catalog/product", { params: { ncm: digits(ncm), product, cnpjRaiz: root(cnpj) } })).data.values ?? {};

export const saveCatalogProductValues = async (ncm: string, product: string, cnpj: string | undefined, values: AttrValues) =>
  (await api.put("/api/catalog/product", { ncm: digits(ncm), product, cnpjRaiz: root(cnpj), values })).data;
